export default class Encoding {
    public static isBase64(text: string): boolean {
        const normalized = text.replace(/_/g, '/');
        return normalized.length % 4 === 0 && /^[A-Za-z0-9+/]*={0,2}$/.test(normalized);
    }

    public static encode(text: string) {
        try {
            return window.btoa(text);
        } catch {
            return '';
        }
    }

    public static decode(text: string) {
        if (!Encoding.isBase64(text)) {
            return text;
        }

        try {
            const base64 = text.replace(/_/g, '/');
            return window.atob(base64);
        } catch {
            // Not b64 -> Backward compat
            return text;
        }
    }
}
